import gql from 'graphql-tag';
import { trendFragment } from '../fragments/trend.fragment';

export const getTrendingNowQuery = gql`
  query trendingNow($count: Int) {
    trendingNow(count: $count) {
      trends {
        ...trendFragment
      }
    }
  }
  ${trendFragment}
`;
